export default "__VITE_ASSET__SDRaEs2i__"